import {
  IActivityScheduleCapacityView,
  IWeekdayActivityScheduleBase,
} from '../models/activities';

interface ICapacitySource {
  booked: number;
  capacityView: IActivityScheduleCapacityView;
  lodgerBooked: number;
}

interface IDisplayCapacitySource {
  capacityView: IActivityScheduleCapacityView;
}

export const getScheduleCapacityView = (
  schedule: ICapacitySource,
): IActivityScheduleCapacityView => {
  if (schedule.capacityView.mode === 'LODGER_ONLY') {
    const booked = schedule.lodgerBooked;

    return {
      available:
        typeof schedule.capacityView.vacancies === 'number'
          ? Math.max(0, schedule.capacityView.vacancies - booked)
          : null,
      booked,
      mode: 'LODGER_ONLY',
      vacancies: schedule.capacityView.vacancies,
    };
  }

  return {
    available:
      typeof schedule.capacityView.vacancies === 'number'
        ? Math.max(0, schedule.capacityView.vacancies - schedule.booked)
        : null,
    booked: schedule.booked,
    mode: 'DEFAULT',
    vacancies: schedule.capacityView.vacancies,
  };
};

export const getScheduleDisplayedVacancies = (
  schedule: IDisplayCapacitySource,
): number | null => schedule.capacityView.vacancies;

export const getScheduleAvailableVacancies = (
  schedule: ICapacitySource,
): number | null => getScheduleCapacityView(schedule).available;

export const getSchedulesAvailableVacancies = (
  schedules: IWeekdayActivityScheduleBase[],
): number | null => {
  const availableVacancies = schedules.map(getScheduleAvailableVacancies);

  if (availableVacancies.some((vacancies) => typeof vacancies !== 'number')) {
    return null;
  }

  return availableVacancies.reduce<number>(
    (total, vacancies) => total + (vacancies ?? 0),
    0,
  );
};
